<template>
  <div class="container" @click="onClick">
    <div class="icon"></div>
    <div class="text" v-html="displayText"></div>
  </div>
</template>

<script>
import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

import { TELEGRAM_OPEN } from 'root/.env';

export default {
  computed: {
    displayText() {
      return this.$t('receive.notifications.from.telegram');
    },
  },
  methods: {
    onClick() {
      HTTPService.telegramBotGetToken()
        .then(response => {
          window.location.assign(`https://${TELEGRAM_OPEN}?start=${response.data}`);
        })
        .catch(error => {
          this.$alert({
            type: 'warning',
            text: this.$t('binding.bot.error'),
          });

          logrocket.logger(error);
        });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import './information-panel'

  .container
    &:hover
      border-color: #34A7F9

  .icon
    background:
      color: #34A7F9
      image: url('~@/assets/svg/obsidian/telegram.svg')
</style>
